import { ReactNode } from 'react'
import { BudgetItem } from '../../entities/Budget'

type SummaryItem = {
  key: keyof BudgetItem
  label: string
  units: ReactNode
}

export const summaryItems: SummaryItem[] = [
  {
    key: 'approvedLimit',
    label: 'Утвержденный лимит с фактической инфляцией',
    units: (
      <>
        руб на м<sup>2</sup>
      </>
    )
  },
  {
    key: 'kmp',
    label: 'КМП',
    units: (
      <>
        руб на м<sup>2</sup>
      </>
    )
  },
  {
    key: 'budget',
    label: 'Текущий лимит',
    units: (
      <>
        руб на м<sup>2</sup>
      </>
    )
  },
  {
    key: 'contracting',
    label: 'Контрактация',
    units: (
      <>
        руб на м<sup>2</sup>
      </>
    )
  }
]
